import { SideMenu } from './../Menu/V2/SideMenu'
import { GoToTop } from './../Common/GoToTop'
import { Credits } from './../Common/Credits/Credits'


const BodyWithSideMenu = ({ children, page, theme, propositionValue, idHelp, role }) => {
    return (
        <>
            {/* Contenedor principal */}
            <div className='SideMenu'>
                {/* Menú lateral */}
                <SideMenu page={page} theme={theme} propositionValue={propositionValue} idHelp={idHelp} role={role} />

                {/* Contenido de la página */}
                <main className='SideMenu__Body'>
                    {/* Área scrolleable */}
                    <div className='SideMenu__Content'>
                        {/* Columna para empujar Credits al fondo si hay poco contenido */}
                        <div className='SideMenu__ContentInner'>
                            {children}
                            <Credits />
                        </div>
                    </div>
                </main>

                {/* Botón para ir al inicio de la página */}
                <GoToTop />
            </div>
            
        </>
    )
}

export { BodyWithSideMenu };